import { forwardRef, useImperativeHandle, useState } from 'react';
import { Toast } from '@belong/ui';

type Variant = 'success' | 'error';
export type FeedbackMessageRef = {
  showMessage: (message: string, variant: Variant) => void;
  clearMessage: () => void;
};
type FeedbackMessageProps = { key?: string; autocloseDuration?: number };

export const FeedbackMessage = forwardRef<
  FeedbackMessageRef,
  FeedbackMessageProps
>(function ({ autocloseDuration = 3000 }, ref): JSX.Element {
  const [feedbackMessageData, setFeedbackMessageData] = useState<{
    message?: string;
    variant?: 'success' | 'error';
  }>({});

  function showMessage(message: string, variant: Variant) {
    setFeedbackMessageData({ message, variant });
  }

  function clearMessage() {
    setFeedbackMessageData({});
  }

  useImperativeHandle(ref, () => ({
    showMessage,
    clearMessage,
  }));

  return (
    <Toast
      isVisible={!!feedbackMessageData?.message}
      variant={feedbackMessageData?.variant === 'error' ? 'danger' : 'default'}
      autocloseDuration={autocloseDuration}
      onClose={clearMessage}
    >
      {feedbackMessageData?.message || ''}
    </Toast>
  );
});

FeedbackMessage.displayName = 'FeedbackMessage';
